import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom'
import { getNotificationByID, markAsRead, NotificationData } from './function';
import Layout from 'Layout'

export default function NotificationDetailPage() {
    const { id } = useParams();
    const [notificationData, setNotificationData] = useState<NotificationData | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [titleHandled, setTitleHandled] = useState<string>('')
    const [notificationType, setNotificationType] = useState<string>('system');

    const parseTitle = (rawTitle: string) => {
        let title2 = rawTitle;
        let type = 'system';

        if (rawTitle.startsWith("[true]") || rawTitle.toLowerCase().includes('reminder')) {
            type = 'reminder';
            title2 = rawTitle.replace("[true]", "").trim();
        } else if (rawTitle.startsWith("[WARNING]") || rawTitle.toLowerCase().includes('risk') || rawTitle.toLowerCase().includes('cảnh báo')) {
            type = 'risk';
            title2 = rawTitle.replace("[WARNING]", "").trim();
        }

        setNotificationType(type);
        setTitleHandled(title2);
    };

    function formatNotificationMessage(message: string): string {
        let textPart = message;
        const match = message.match(/Details:\s*(\{.*\})/);
        if (match) {
            try {
                textPart = message.split("Details:")[0].trim();
            } catch (e) {
                // keep original text if parse fails
            }
        }
        return textPart;
    }

    useEffect(() => {
        getNotificationByID(Number(id)).then(data => {
            if (data) {
                parseTitle(data.title)
                setNotificationData(data);
            } else {
                setError('Notification not found');
            }
            setLoading(false);
        }).catch(err => {
            setError('Error fetching notification');
            setLoading(false);
        });
        markAsRead(Number(id));
    }, [id]);

    if (loading) {
        return <Layout><div style={{ padding: '40px', textAlign: 'center' }}>Loading...</div></Layout>;
    }

    if (error) {
        return <Layout><div style={{ padding: '40px', textAlign: 'center', color: 'var(--red, #e24b4a)' }}>Error: {error}</div></Layout>;
    }

    if (!notificationData) {
        return <Layout><div style={{ padding: '40px', textAlign: 'center' }}>No notification data available.</div></Layout>;
    }

    const getTypeLabel = (type: string) => {
        switch (type) {
            case 'reminder': return 'Nhắc nhở';
            case 'risk': return 'Cảnh báo';
            default: return 'Hệ thống';
        }
    };

    return (
        <Layout>
            <div style={{ padding: '24px 20px 0', maxWidth: '850px', margin: '0 auto', width: '100%' }}>
                <Link to="/notifications" style={{ textDecoration: 'none', color: 'var(--navy, #0b1c2e)', display: 'inline-flex', alignItems: 'center', marginBottom: '20px', fontWeight: 600, fontSize: '13.5px' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16" style={{ marginRight: '8px' }}>
                        <path fillRule="evenodd" d="M15 8a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 7.5H14.5A.5.5 0 0 1 15 8z" />
                    </svg>
                    Back to Notifications
                </Link>

                <div className="detailNotification" style={{ 
                    padding: '28px', 
                    borderRadius: '16px', 
                    background: 'var(--card, #ffffff)',
                    border: '1px solid var(--border, #e9e6dd)',
                    boxShadow: '0 10px 30px -10px rgba(11,28,46,.1)'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px' }}>
                        <h2 style={{ fontSize: '18px', fontWeight: 700, color: 'var(--ink, #0b1c2e)', margin: 0 }}>
                            {titleHandled}
                        </h2>
                        <span style={{ 
                            fontSize: '11px', 
                            fontWeight: 700, 
                            padding: '4px 10px', 
                            borderRadius: '6px', 
                            backgroundColor: notificationType === 'reminder' ? '#e6faf5' : notificationType === 'risk' ? '#fdecec' : '#faf3df', 
                            color: notificationType === 'reminder' ? '#059a7f' : notificationType === 'risk' ? '#e24b4a' : '#96790f' 
                        }}>
                            {getTypeLabel(notificationType)}
                        </span>
                    </div>

                    {notificationData.subtitle && (
                        <h3 style={{ fontSize: '14px', color: 'var(--ink-soft, #5b6472)', fontWeight: 500, margin: '0 0 8px' }}>
                            {notificationData.subtitle.replace(/^\[|\]$/g, '')}
                        </h3>
                    )}

                    <p style={{ color: 'var(--ink-faint, #93989f)', fontSize: '12px', marginBottom: '20px', borderBottom: '1px solid var(--border, #e9e6dd)', paddingBottom: '12px' }}>
                        {new Date(notificationData.createdAt).toLocaleString().replace(/^\[|\]$/g, '')}
                    </p>

                    <div style={{ marginTop: '16px', whiteSpace: 'pre-wrap', fontSize: '14px', lineHeight: 1.6, color: 'var(--ink, #0b1c2e)' }}>
                        {formatNotificationMessage(notificationData.message)}
                    </div>
                </div>
            </div>
        </Layout>
    );
}